import React from "react";
import { getParentCategories } from "services/parentcategory.service";
import { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { Badge } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import MultipleCheckbox from "components/MutlpleCheckbox";
import SweetAlert from "react-bootstrap-sweetalert";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import Switch from "react-switch";

import {
  deleteParentCategory,
  getAllParentCategoriesList,
} from "services/V2_APIs/DoctorsConsultationApis/parentCategories.service";
import "./styles.scss";
import CreateParentCategory from "./Create";
import Spinner from "components/spinner";
export const ParentCategoriesMain = props => {
  const [list, setList] = useState([]);
  console.log(list, "list");
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState([]);
  console.log(values, "values");
  const [modal, setModal] = useState(false);
  const [activedata, setActiveData] = useState(false);
  const [delete_modal, setDelete_modal] = useState(false);
  const [deleteId, setDeleteid] = useState(null);
  const [allList, setAllList] = useState([]);
  const [tempList, setTempList] = useState([]);
  const [typeFilter, setTypeFilter] = useState([]);
  const typeFilterOptions = ["Male", "Female", "Kids"];
  const [selectedGenders, setSelectedGenders] = useState([]); // Stores selected genders like ["Male", "Female"]

  const handleGenderToggle = gender => {
    let updatedGenders = [...selectedGenders];
    const index = updatedGenders.indexOf(gender);

    if (index > -1) {
      // If gender already selected, remove it
      updatedGenders.splice(index, 1);
    } else {
      // Add gender if not selected
      updatedGenders.push(gender);
    }

    setSelectedGenders(updatedGenders);

    // Filter data based on selected genders
    if (updatedGenders.length > 0) {
      let filteredList = tempList.filter(item =>
        updatedGenders.includes(item.genderType)
      );
      setList(filteredList);
    } else {
      setList(tempList); // If none selected, show all
    }
  };

  const handleSearch = search => {
    if (search) {
      let tempList = _.cloneDeep(allList);
      let filterList = tempList.filter(ele =>
        ele?.name?.toLowerCase().includes(search.toLowerCase())
      );
      setList(filterList);
    } else {
      setList(allList);
    }
  };

  const toggle = () => {
    if (modal) {
      setActiveData(null);
    }
    setModal(!modal);
  };

  useEffect(() => {
    getParentCatList();
    // getCataegories();
  }, []);

  const getParentCatList = () => {
    getAllParentCategoriesList()
      .then(res => {
        if (res?.success === true) {
          setList(res?.data);
          setTempList(res?.data);
          setAllList(res?.data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleClick = ele => {
    setValues(ele);
  };

  //delete
  const removeParentCat = id => {
    setLoading(true);
    deleteParentCategory(id)
      .then(res => {
        setDelete_modal(false);
        getParentCatList();
        setValues([]);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };

  const onClickDelete = id => {
    setDeleteid(id);
    setDelete_modal(true);
  };

  const handleOnDelete = () => {
    removeParentCat(deleteId);
  };

  const stayHere = () => {
    setDelete_modal(false);
  };
  const deletePopup = () => {
    return (
      <SweetAlert
        title="Are you sure ?"
        warning
        onConfirm={handleOnDelete}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={handleOnDelete}
            >
              Delete
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              cancel
            </Button>
          </React.Fragment>
        }
      >
        You will not be able to recover this record
      </SweetAlert>
    );
  };

  const renderParentView = () => {
    return (
      <div>
        <div className="text-end mb-3">
          <Button type="button" color="primary" className="" onClick={toggle}>
            <i className="bx bx-user-plus font-size-16 align-middle me-2"></i>
            Add Parent Category
          </Button>
        </div>
        <Card className="detail-card">
          <CardBody className="p-3">
            {(!values || Object.keys(values).length === 0) && (
              <div className="empty-card">
                <i className="mdi mdi-arrow-left-circle empty-card__icon"></i>
                <p className="empty-card__text">Please Select </p>
              </div>
            )}

            {values && Object.keys(values).length > 0 && (
              <div className="gender-card">
                <div className="d-flex align-items-center justify-content-end ">
                  <button
                    className="gender-card__button gender-card__button--edit me-4"
                    onClick={() => {
                      setActiveData(values);
                      toggle();
                    }}
                  >
                    <i className="mdi mdi-pencil text-info"></i>
                  </button>

                  <button
                    className="gender-card__button gender-card__button--delete"
                    onClick={() => onClickDelete(values._id)}
                  >
                    <i className="mdi mdi-delete text-danger"></i>
                  </button>
                </div>
                <Row>
                  <Col md={4} className="">
                    <div className="text-center">
                      <img
                        src={values.image}
                        alt=""
                        className="img-thumbnail profile rounded-circle"
                      />
                      <h5 className="mt-4 text-primary"></h5>
                    </div>
                  </Col>
                  <Col md={8} className=" pt-4 mb-4 px-0 view_detail">
                    <Row className="mx-3 ps-2">
                      <p className="ps-0">
                        <span className="pe-3 fw-bold"> Name </span>{" "}
                        <span className="text-muted">{values.name} </span>
                      </p>
                    </Row>
                    {/* <div className="me-3 hr"> </div> */}
                    <Row className="mx-3">
                      <Col md={4} className="mt-3">
                        <p className="fw-bold mb-1">Type</p>
                        <p className="text-muted">{values?.genderType}</p>
                      </Col>
                      <Col md={4} className="mt-3">
                        <p className="fw-bold mb-1">Order</p>
                        <p className="text-muted">{values?.order}</p>
                      </Col>
                      <Col md={4} className="mt-3">
                        <p className="fw-bold mb-1">status</p>
                        <p className="text-muted">
                          <Badge
                            className={
                              values?.status === "Active"
                                ? "font-size-12 badge-soft-" + "success"
                                : "font-size-12 badge-soft-" + "danger"
                            }
                            color={
                              values?.status === "Active"
                                ? "bg-" + "success"
                                : "bg-" + "danger"
                            }
                            pill
                          >
                            {values?.status}
                          </Badge>
                        </p>
                      </Col>
                    </Row>
                    {/* <div className=" mt-2 me-3 hr"> </div> */}
                    <Row className="mx-3">
                      <Col md={6} className="mt-3">
                        <p className="fw-bold mb-1">Created</p>
                        <p className="text-muted">
                          {moment(
                            values.createdAt ? values.createdAt : "_"
                          ).format("MMM Do YYYY")}
                        </p>
                      </Col>
                      <Col md={6} className="mt-3">
                        <p className="fw-bold mb-1">Last Updated</p>
                        <p className="text-muted">
                          {moment(
                            values.updatedAt ? values.updatedAt : "_"
                          ).format("MMM Do YYYY")}
                        </p>
                      </Col>
                    </Row>
                    <Row className="mx-3">
                      <Col md={12} className="mt-3">
                        <p className="fw-bold mb-1">Tagline</p>
                        <p
                          className="text-muted"
                          dangerouslySetInnerHTML={{
                            __html: values?.tagline,
                          }}
                        />
                      </Col>
                      <Col md={12} className="mt-3">
                        <p className="fw-bold mb-1">Description</p>
                        <p
                          className="text-muted"
                          dangerouslySetInnerHTML={{
                            __html: values?.description,
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    );
  };

  //checkbox.......//
  const handleCheckboxChange = text => {
    setLoading(true);
    let indx = typeFilter.indexOf(text);
    if (indx >= 0) {
      typeFilter.splice(indx, 1);
    } else {
      typeFilter.push(text);
    }
    if (typeFilter.length > 0) {
      let newList = _.filter(tempList, function (obj) {
        if (typeFilter.includes(obj.genderType)) {
          return obj;
        }
      });
      setList(newList);
    } else {
      setList(tempList);
    }
    setTypeFilter(typeFilter);
    setLoading(false);
  };

  const checkboxItems = () => {
    return (
      <React.Fragment>
        {typeFilterOptions.map(option => (
          <MultipleCheckbox
            key={option}
            text={option}
            handleOnChange={text => handleCheckboxChange(text)}
          ></MultipleCheckbox>
        ))}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <Spinner loading={loading} />
      <div className="page-content">
        <MetaTags>
          <title>Providers | stylepro</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="Doctors consultation"
            breadcrumbItem="Parent Categories List"
          />
          <BreadcrumbSub
            subtile="Parent Categories"
            SubBreadcrumbItem="Parent categories List"
          />

          <Row>
            <Col md="4">
              <div className="d-flex align-items-center flex-wrap">
                <div className="custom-search-box me-2">
                  <div className="position-relative">
                    <i className="bx bx-search-alt custom-search-icon" />
                    <input
                      className="form-control custom-search-input"
                      type="search"
                      id="example-search-input"
                      placeholder=" Search "
                      onChange={event => handleSearch(event.target.value)}
                    />
                  </div>
                </div>
                <div className="gender-filter-buttons d-flex align-items-center gap-3">
                  {/* Male Button */}
                  <button
                    className={`gender-btn male-btn ${
                      selectedGenders.includes("Male") ? "active" : ""
                    }`}
                    onClick={() => handleGenderToggle("Male")}
                  >
                    <i className="bx bx-male"></i>
                  </button>

                  {/* Female Button */}
                  <button
                    className={`gender-btn female-btn ${
                      selectedGenders.includes("Female") ? "active" : ""
                    }`}
                    onClick={() => handleGenderToggle("Female")}
                  >
                    <i className="bx bx-female"></i>
                  </button>

                  {/* Unisex Button */}
                  <button
                    className={`gender-btn unisex-btn ${
                      selectedGenders.includes("Unisex") ? "active" : ""
                    }`}
                    onClick={() => handleGenderToggle("Unisex")}
                  >
                    <i className="bx bx-user"></i>
                  </button>
                </div>
              </div>

              {list &&
                list.map((ele, index) => (
                  <div
                    key={ele._id}
                    onClick={() => handleClick(ele, index)}
                    role="button"
                    className={`custom-card mt-3 ${
                      ele.status === "Active"
                        ? "custom-card--active"
                        : "custom-card--inactive"
                    }`}
                  >
                    <div className="custom-card__row">
                      {/* Image */}
                      <div className="custom-card__image-wrapper">
                        <img
                          src={ele.image}
                          alt=""
                          className="custom-card__image"
                        />
                      </div>

                      {/* Content */}
                      <div className="custom-card__content">
                        <h4 className="custom-card__name">{ele.name}</h4>
                        <p className="custom-card__text">
                          <b>Created: </b>{" "}
                          {moment(ele.createdAt).format("MMM Do YYYY")}
                        </p>
                        <p className="custom-card__text">
                          <b>Updated: </b>{" "}
                          {moment(ele.updatedAt).format("MMM Do YYYY")}
                        </p>
                      </div>

                      {/* Badge */}
                      <div className="custom-card__badge-wrapper">
                        <span
                          className={`custom-card__badge ${
                            ele.genderType === "Female"
                              ? "custom-card__badge--female"
                              : ele.genderType === "Male"
                              ? "custom-card__badge--male"
                              : "custom-card__badge--unisex"
                          }`}
                        >
                          {ele.genderType}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              {list?.length <= 0 && (
                <div className="custom-card mt-3">
                  <div className="text-center">
                    <h5 className="p-5">No Data</h5>
                  </div>
                </div>
              )}
              {/* </Card> */}
            </Col>
            <Col md="8">{renderParentView()}</Col>
          </Row>
        </Container>
      </div>
      <div>
        {modal && (
          <CreateParentCategory
            toggle={toggle}
            modal={modal}
            SelectedParentcatdata={activedata}
            reload={getParentCatList}
          />
        )}
      </div>
      {delete_modal ? deletePopup() : null}
    </React.Fragment>
  );
};
export default ParentCategoriesMain;
